import { hc } from 'hono/client';
const client = hc('');
export const hcWithType = (...args) => hc(...args);
//# sourceMappingURL=hc.js.map